export const ROW_HEIGHT = 36;
export const VIEWPORT_HEIGHT = 260;
